import { render } from "./PhiDichVuVer2.vue?vue&type=template&id=825d75dc&scoped=true"
const script = {}

import "./PhiDichVuVer2.vue?vue&type=style&index=0&id=825d75dc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-825d75dc"]])

export default __exports__